document.addEventListener("DOMContentLoaded", function () {
  console.log("[INF] init");

  // ===== תצורה =====
  const GRID_SELECTOR = ".new-grid.product-grid.collection-grid"; // הגריד של המוצרים
  const PAGINATION_SELECTOR = ".pagination";                      // הפאג'ינציה
  const OBSERVER_THRESHOLD = 0;
  const OBSERVER_ROOT_MARGIN = "0px 0px 400px 0px";

  // ===== בדיקת תמיכה =====
  if (!("IntersectionObserver" in window) ||
      !("fetch" in window) ||
      !("URLSearchParams" in window) ||
      !("DOMParser" in window)) {
    console.log("[INF] browser too old for infinite scroll, leaving pagination");
    return;
  }

  const grid = document.querySelector(GRID_SELECTOR);
  const paginations = document.querySelectorAll(PAGINATION_SELECTOR);
  if (!grid) {
    console.log("[INF] no product grid found");
    return;
  }
  if (!paginations.length) {
    console.log("[INF] no pagination found – nothing to do");
    return;
  }

  // הפאג'ינציה הראשית שנשתמש בה (זו של העמוד הראשון)
  const pagination = paginations[0];

  // אם יש כבר הכפלות – למחוק את העודפות
  paginations.forEach((el, idx) => {
    if (idx > 0) el.remove();
  });

  console.log("[INF] grid + pagination found, starting infinite scroll enhancement");

  // ===== יצירת loader =====
  const loader = document.createElement("div");
  loader.className = "inf-loader";
  loader.setAttribute("aria-live", "polite");
  loader.setAttribute("role", "status");
  loader.innerHTML = '<span class="inf-loader__text"></span>';
  const loaderText = loader.querySelector(".inf-loader__text");

  loader.style.minHeight = "40px";
  loader.style.textAlign = "center";
  loader.style.padding = "20px 0";
  loader.style.fontSize = "0.9rem";
  loader.style.opacity = "0";

grid.insertAdjacentElement("afterend", loader);
  pagination.style.display = "none";

  // ===== ניהול מצב העמודים =====
  const params = new URLSearchParams(window.location.search);
  let currentPage = Number(params.get("page") || "1");
  let isLoading = false;
  let finished = false;

  function setLoader(state, message) {
    switch (state) {
      case "idle":
        loader.style.opacity = "0";
        loaderText.textContent = "";
        loader.classList.remove("inf-loader--active", "inf-loader--error", "inf-loader--done");
        break;
      case "loading":
        loader.style.opacity = "1";
        loaderText.textContent = message || "טוען מוצרים נוספים...";
        loader.classList.add("inf-loader--active");
        loader.classList.remove("inf-loader--error", "inf-loader--done");
        break;
      case "done":
        loader.style.opacity = "1";
        loaderText.textContent = message || "אין עוד מוצרים להצגה";
        loader.classList.add("inf-loader--done");
        loader.classList.remove("inf-loader--active", "inf-loader--error");
        break;
      case "error":
        loader.style.opacity = "1";
        loaderText.textContent = message || "אירעה שגיאה בטעינת מוצרים נוספים";
        loader.classList.add("inf-loader--error");
        loader.classList.remove("inf-loader--active", "inf-loader--done");
        break;
    }
  }

  async function loadNextPage() {
    if (isLoading || finished) return;

    isLoading = true;
    setLoader("loading", "טוען מוצרים נוספים...");

    const url = new URL(window.location.href);
    const nextPage = currentPage + 1;
    url.searchParams.set("page", String(nextPage));

    console.log("[INF] loading page", nextPage, "=>", url.toString());

    try {
      const res = await fetch(url.toString(), { credentials: "same-origin" });
      if (!res.ok) throw new Error("Failed with status " + res.status);

      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const nextGrid = doc.querySelector(GRID_SELECTOR);
      if (!nextGrid) {
        console.log("[INF] no grid in next page – stopping");
        finished = true;
        setLoader("done", "אין עוד מוצרים להצגה");
        observer.unobserve(loader);
        return;
      }

      // לא להכניס פאג'ינציה של העמוד הבא
      nextGrid.querySelectorAll(PAGINATION_SELECTOR).forEach(el => el.remove());
const items = Array.from(
  nextGrid.querySelectorAll('.grid-item.grid-product')
);


      if (!items.length) {
        console.log("[INF] no items in next page – stopping");
        finished = true;
        setLoader("done", "אין עוד מוצרים להצגה");
        observer.unobserve(loader);
        return;
      }

      const frag = document.createDocumentFragment();
      items.forEach(el => frag.appendChild(el));
      grid.appendChild(frag);

      currentPage = nextPage;
      console.log("[INF] appended", items.length, "items; now at page", currentPage);

      setLoader("idle");
    } catch (err) {
      console.error("[INF] error loading next page", err);
      finished = true;
      setLoader("error", "אירעה שגיאה בטעינת מוצרים נוספים");
      observer.unobserve(loader);
    } finally {
      isLoading = false;
    }
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          loadNextPage();
        }
      }
    },
    {
      root: null,
      threshold: OBSERVER_THRESHOLD,
      rootMargin: OBSERVER_ROOT_MARGIN,
    }
  );

  observer.observe(loader);
  setLoader("idle");

  // ===== כשחוזרים מהיסטוריית הדפדפן – לנקות רק את ההודעה, לא את הנתונים =====
  window.addEventListener("pageshow", function (event) {
    const entries = performance.getEntriesByType && performance.getEntriesByType("navigation");
    const navType = entries && entries[0] && entries[0].type; // "navigate" | "reload" | "back_forward"

    const fromHistory = event.persisted === true || navType === "back_forward";

    if (fromHistory && finished) {
      // כבר אין עוד מוצרים, אבל לא רוצים לראות את ההודעה שוב
      setLoader("idle");  // מסתיר את הטקסט והאופסיטי, finished נשאר true => אין טעינות נוספות
    }
  });
});
